module.exports = __webpack_public_path__ + "static/img/hour_img_bg.05c8367.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/hour_img_bg.png
// module id = BQG+
// module chunks = 41